import { render, staticRenderFns } from "./VoiceMode.vue?vue&type=template&id=b0c206d0"
import script from "./VoiceMode.vue?vue&type=script&lang=js"
export * from "./VoiceMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports